import { useEffect, useState } from 'react'
import styled from 'styled-components'
import ErrorableInputWrapper from '../common/ErrorableInputWrapper'
import LabeledInput from '../LabeledInput'
import Text from '../../atoms/Text'
import { validatePassword } from '../../../utils/userValidation'
import MainButton from '../../atoms/MainButton'
import { ResetPassword } from '../../../api/auth'
import { useNavigate } from 'react-router-dom'

const Wrapper = styled.form`
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 20px; 
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px; /* Wrapper 최대 폭과 맞춤 */
  padding: 0 20px;   /* 좌우 여유 */
`

const NewPasswordStep = ({ email, newPassword, setNewPassword }) => {
  const [errors, setErrors] = useState({pwd: '', confirm: ''}) // 에러 메시지 상태관리
  // input 이벤트 핸들러
  const handleChange = (field) => (e) => {
    setNewPassword(prev => ({ ...prev, [field]: e.target.value }));
  }
  const handleBlur = (field) => {
    let error = '';
    if (field === 'pwd') {
      if (!newPassword.pwd?.trim()) error = "새 비밀번호를 입력해주세요.";
      else if (!validatePassword(newPassword.pwd)) error = "비밀번호는 숫자/영문/특수문자 중 2가지 조합이며 최소 8자 이상 입니다.";
    }
    if (field === 'confirm') {
      if (!newPassword.confirm?.trim()) error = "새 비밀번호 확인을 입력해주세요.";
      else if (newPassword.pwd !== newPassword.confirm) error = "비밀번호가 일치하지 않습니다.";
    }
    setErrors(prev => ({ ...prev, [field]: error }));
  }

  // 비밀번호 일치 실시간 체크
  useEffect(() => {
    if (newPassword.confirm && newPassword.pwd !== newPassword.confirm) {
      setErrors(prev => ({ ...prev, confirm: '비밀번호가 일치하지 않습니다.' }));
    } else {
      setErrors(prev => ({ ...prev, confirm: '' }));
    }
  }, [newPassword.pwd, newPassword.confirm]);

  const isBtnValid = 
    newPassword.pwd?.trim() &&
    !errors.pwd &&
    newPassword.confirm?.trim() &&
    !errors.confirm;

  const navigate = useNavigate();

  const handleSubmit = async(e) => {
    e?.preventDefault();
    if (!isBtnValid) return;

    const payload = {email: email, password: newPassword.pwd}

    try {
      await ResetPassword(payload)
      alert("비밀번호 재설정이 완료되었습니다. 다시 로그인해주세요.");
      navigate('/login')
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <Wrapper onSubmit={handleSubmit}>
      <Text variant="headline1" weight="medium">비밀번호를 재설정 해주세요.</Text>
      <ErrorableInputWrapper $error={!!errors.pwd} message={errors.pwd}>
        <LabeledInput
          type="password"
          name="newPassword"
          autoComplete="new-password"
          label="새 비밀번호"
          placeholder="숫자/영문/특수 문자 조합, 8자 이상"
          value={newPassword.pwd}
          onChange={handleChange('pwd')}
          onBlur={() => handleBlur('pwd')}
          $error={!!errors.pwd}
        />
      </ErrorableInputWrapper>
      <ErrorableInputWrapper $error={!!errors.confirm} message={errors.confirm}>
        <LabeledInput
          type="password"
          name="passwordConfirm"
          autoComplete="new-password"
          label="새 비밀번호 확인"
          placeholder="비밀번호 확인"
          value={newPassword.confirm}
          onChange={handleChange('confirm')}
          onBlur={() => handleBlur('confirm')}
          $error={!!errors.confirm}
        />
      </ErrorableInputWrapper>
      <ButtonWrapper>
        <MainButton
          $variant="primary"
          title="확인"
          disabled={!isBtnValid}
          type="submit"
        />
      </ButtonWrapper>
    </Wrapper>
  )
}

export default NewPasswordStep
